<template>
  <button class="button">
    <slot></slot>
  </button>
</template>

<script>
export default {
  name: 'Button'
}
</script>

<style lang="scss" scoped>
.button {
  background: $c-dark;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);
  color: white;
  padding: 10px 25px 12px;
  width: 100%;
  border: none;
  border-radius: 22.5px;
  font-size: $fs-normal;
  font-weight: $fw-medium;
  font-family: $ff-barlow;
  line-height: $lh-heading;
  margin: 34px auto 0;
  cursor: pointer;
  max-width: 345px;
}
</style>
